export default function formatMobileNumber(country_code, phone) {
  if (!phone) {
    return undefined
  } else if (!country_code) {
    return phone
  } else {
    return country_code + phone
  }
}
